export type Mem0Tag = "gpt" | "ui";

/** Max characters for a single memory text, enforced on every write path. */
export const MAX_MEMORY_CHARS = 200;

export type Mem0PublicItem = {
   id: string;
   text: string;
   tags: string;
   org_id: string;
   /** ISO 8601 from the sidecar; absent until Bifrost forwards it. */
   created_at?: string;
};

export type Mem0ListResponse = {
   items: Mem0PublicItem[];
};

export type Mem0AddResponse = {
   ok: boolean;
   queued: boolean;
   items?: Mem0PublicItem[];
};

export type Mem0PatchResponse = {
   item: Mem0PublicItem;
};

export type Mem0DeleteResponse = {
   ok: boolean;
   id: string;
};

export class Mem0ClientError extends Error {
   readonly status: number;
   readonly errorKey: string;
   readonly detail: string;

   constructor(status: number, errorKey: string, detail = "") {
      super(detail || errorKey);
      this.name = "Mem0ClientError";
      this.status = status;
      this.errorKey = errorKey;
      this.detail = detail;
   }
}

export function memoryErrorKeyFromSidecar(status: number, detail: string): string {
   const normalized = detail.toLowerCase();
   if (status === 400 && normalized.includes("blocked by memory policy")) {
      return "memory.policyBlocked";
   }
   if (status === 400 && normalized.includes("not a durable memory")) {
      return "memory.notDurable";
   }
   if (status === 404) {
      return "memory.notFound";
   }
   return "memory.requestFailed";
}
